<template>
  <v-container v-if="membershipsFiltered" density="compact" dense="true">
    <h1>Adult Membership Options</h1>
    <h4>
      Looking for
      <RouterLink to="youth-memberships">Youth Programs</RouterLink>?
    </h4>
    <v-row justify="start">
      <v-col class="d-flex" v-for="membershipType in membershipsFiltered">
        <MembershipTypeCard
          :membership-type="membershipType"
          :person="currentPersonRef"
        />
      </v-col>
      <v-col>
        <DamageWaiverTypeCard :person="currentPersonRef" />
      </v-col>
    </v-row>
  </v-container>
  <v-progress-linear v-else indeterminate />
</template>

<script lang="ts" setup>
import { useMembershipPurchaseOptions } from "@/composables/shop/useMembershipPurchaseOptions";
import { useUser } from "@/composables/useUser";
const { currentPersonRef } = useUser();
const membershipsFiltered = useMembershipPurchaseOptions(1);
//const membershipTypeName = appData.membershipTypes
//const membershipTypeDescription = appData.membershipTypeDiscounts
</script>
